<div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom secondaryMenu px-4 py-3">
    <div class="d-flex flex-column col">
        <h3 class="mt-0 mb-1">Job Chain Cycle Report</h3>
        <p-breadcrumb [model]="items"></p-breadcrumb>
    </div>
    <div class="d-flex justify-content-start justify-content-md-end col mt-2 mt-md-0">
        <button pButton type="button" icon="pi pi-table" label="Excel" iconPos="left" class="me-3"></button>
        <button pButton type="button" icon="pi pi-print" label="Print" iconPos="left" class="p-button-success"></button>
    </div>
</div>

<div class="p-white shadow m-3">
    <p-table [value]="products" [autoLayout]="true"  dataKey="name">
        <ng-template pTemplate="caption">
            <div class="d-flex flex-row justify-content-between">
                <span class="p-input-icon-left p-ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"  placeholder="Search keyword" />
                </span>
                <button pButton label="Clear" class="p-button-outlined" icon="pi pi-filter-slash"></button>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 3rem"></th>
                <th pSortableColumn="name">Chain Name <p-sortIcon field="name"></p-sortIcon></th>
                <th>Chain Code</th>
                <th>Description</th>
                <th>Company</th>
                <th>Operation Group</th>
                <th>Created By</th>
                <th>Created On</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product let-expanded="expanded">
            <tr>
                <td>
                    <button type="button" pButton pRipple [pRowToggler]="product" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                </td>
                <td><a> Fuel Charges Fleet Chain </a></td>
                <td>JC62 506 973</td>
                <td>Fuel Charges Fleet Chain</td>
                <td>Hayleys Agro</td>
                <td>Admin User</td>
                <td>Felix Lowe</td>
                <td>2020 July 12</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-product>
            <tr>
                <td colspan="8">
                    <p-chart type="line" [data]="basicData" [options]="basicOptions" height="200"></p-chart>
                </td>
            </tr>
            
        </ng-template>
    </p-table>
</div>


